import { render, staticRenderFns } from "./settingsInformation.vue?vue&type=template&id=6bf3269e&scoped=true"
import script from "./settingsInformation.vue?vue&type=script&lang=js"
export * from "./settingsInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf3269e",
  null
  
)

export default component.exports